import type { ComponentChildren } from "preact";
import type { SplitCopy } from "../content/index.js";

export interface SplitProps {
  readonly copy: SplitCopy;
  readonly media: ComponentChildren;
  readonly flip?: boolean;
  readonly mediaFirst?: boolean;
  readonly tone?: "plain" | "sunken" | "ink";
}

const TONE = { plain: "", sunken: " is-sunken", ink: " is-ink" } as const;

export function Split({
  copy,
  media,
  flip = false,
  mediaFirst = false,
  tone = "plain",
}: SplitProps) {
  return (
    <section class={`section split${TONE[tone]}`} data-theme={tone === "ink" ? "dark" : undefined}>
      <div
        class={`wrap split-grid${flip ? " is-flipped" : ""}${mediaFirst ? " is-media-first" : ""}`}
      >
        <div class="split-text">
          <p class="micro">{copy.label}</p>
          <h2 class="section-title serif">{copy.title}</h2>
          <p class="split-body">{copy.body}</p>
          {copy.bullets ? (
            <ul class="split-bullets">
              {copy.bullets.map((bullet) => (
                <li key={bullet}>{bullet}</li>
              ))}
            </ul>
          ) : null}
        </div>
        <div class="split-media">{media}</div>
      </div>
    </section>
  );
}
